window.updateCartImages = function() {
  var xhr = new XMLHttpRequest
  xhr.open('GET', '/cart?view=bold_custom_data')
  xhr.addEventListener('load', function() {
    if (xhr.status >= 400 || xhr.readyState !== 4) {
      return
    }
    var dataList = JSON.parse(xhr.responseText)
    dataList.forEach(function(data, i) {
      Object.entries(data).forEach(function(entry) {
        var key = entry[0]
        var imgUri = entry[1]
        var img = document.createElement('img')
        img.src = imgUri
        img.classList.add('bold_cartitem_overlay')
        switch (key) {
          case 'logoEngravingColor':
            img.style.zIndex = 3
            break;
          case 'stainBarrelImage':
            img.style.zIndex = 2
            break;
          case 'handleColorImage':
            img.style.zIndex = 1
            break;
        }
        document.querySelectorAll('.CartItem__ImageWrapper .AspectRatio')[i].append(img)
      })
    })
  })
  xhr.send()
}
